import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import '../style/QuotePage.css';

export default function QuotePage() {
  const onSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <div className="QuotePage">
      <Navbar />

      <main className="QuotePage-main" aria-label="Quote request page">
        <section className="QuotePage-section">
          <div className="QuotePage-inner">
            <h1>Air/Ocean Freight Rates Request</h1>
            <p className="QuotePage-subtitle">
              Provide shipment details and our team will prepare a quotation for
              you.
            </p>

            <form className="QuoteForm" onSubmit={onSubmit}>
              <fieldset className="QuoteForm-fieldset">
                <legend>Client Details</legend>
                <div className="QuoteForm-grid QuoteForm-gridTwo">
                  <label className="QuoteForm-field">
                    <span>Company Name / Individual Full Name</span>
                    <input type="text" required />
                  </label>

                  <label className="QuoteForm-field">
                    <span>Email</span>
                    <input type="email" placeholder="you@example.com" required />
                  </label>

                  <label className="QuoteForm-field">
                    <span>Phone</span>
                    <input type="tel" placeholder="Phone number" />
                  </label>

                  <label className="QuoteForm-field">
                    <span>Port of Loading (POL)</span>
                    <input type="text" placeholder="e.g. Dar es Salaam Port (TZ)" />
                  </label>

                  <label className="QuoteForm-field">
                    <span>Port of Destination (POD)</span>
                    <input type="text" placeholder="e.g. Hamburg Port (DE)" />
                  </label>
                </div>

                <label className="QuoteForm-field">
                  <span>Subject</span>
                  <input
                    type="text"
                    placeholder="e.g. Ex Dar es Salaam Port (Tanzania) to Hamburg Port (Germany)"
                  />
                </label>

                <label className="QuoteForm-field">
                  <span>Cargo Description</span>
                  <textarea
                    rows="4"
                    required
                    placeholder="Item Description / HS Code, Volume or any specific details"
                  />
                </label>
              </fieldset>

              <fieldset className="QuoteForm-fieldset">
                <legend>Attachments</legend>

                <label className="QuoteForm-fileRow">
                  <span>1. Shipping instruction</span>
                  <input type="file" />
                </label>

                <label className="QuoteForm-fileRow">
                  <span>2. Invoice / Packing List</span>
                  <input type="file" />
                </label>

                <label className="QuoteForm-fileRow">
                  <span>3. Other (e.g. Import/Export Permit)</span>
                  <input type="file" />
                </label>
              </fieldset>

              <div className="QuoteForm-actions">
                <button type="submit">Request Quote</button>
              </div>
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
